import React, { useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import PermittedRoutes from '../../shared/PermittedRoutes';
import Link from './Link';

const RenderLink = props => {
  const handleLinkMount = useCallback(({ to }) => {
    PermittedRoutes.register(to);
  }, []);

  if (props.if === false) return false;
  return <Link onMount={handleLinkMount} {...props} />;
};

function NavLinkProvider({ children, history, location }) {
  useEffect(() => {
    if (!PermittedRoutes.isPermitted(location.pathname)) {
      history.push(PermittedRoutes.first);
    }
  }, [history, location.pathname]);

  return children(RenderLink);
}

export default withRouter(NavLinkProvider);
